import config from "../../../config/domain";
import GlobalStore from "../../store/globalStore";
import { ITokenObj } from "../../types/genericTypes";
import { apiService } from "../apiServices";
import servicesList from "../serviceList";
import { decryptJwtToken } from "./encryptionNew";

export const ASelfieLock = (
  callback: CallableFunction,
  applicationId: string,
  action: "ACQUIRE" | "STATUS" | "RELEASE"
) => {
  apiService(
    {
      url: "Document/selfielock",
      method: "POST",
      body: { applicationId, action },
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.selfieLock,
    },
    callback
  );
};

export const AGetIpvOtp = (
  callback: CallableFunction,
  applicationid: string
) => {
  apiService(
    {
      url: "IPV/GetOTP",
      body: {
        ApplicationId: applicationid,
        esigndocumenttype: 0
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getIPVOTP,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-ivp-otp",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AUploadIpv = (callback: CallableFunction, uploadObj: any) => {
  apiService(
    {
      url: "DIYAPI/UploadIPVMerge",
      body: {
        ClientPrimaryDetailId: uploadObj.clientprimarydetailid,
        ApplicationId: uploadObj.applicationid,
        LeadId: uploadObj.leadid,
        ImageName: uploadObj.imageName,
        Image: uploadObj.image,
        ContentType: uploadObj.contentType,
        PanNo: uploadObj.panno,
        IsUpload: 1,
        UtmInfoDetails: uploadObj,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.uploadIPVMerge,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/UploadIPVMerge",
  //     body: uploadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const AUploadIpvNew = (callback: CallableFunction, uploadObj: any) => {
  let userId=0;
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = parseInt(tokenMainObj?.UserId?.toString());
  }
 
  apiService(
    {
      url: "Document/UploadVIPV",
      body: {
        image64: uploadObj?.image64,
        clientPrimaryDetailId: uploadObj?.clientPrimaryDetailId,
        applicationId: uploadObj?.applicationId,
        leadId: uploadObj?.leadId,
        panNo: uploadObj?.panNo,
        width: uploadObj?.width,
        height: uploadObj?.height,
        imageToVideo: uploadObj?.imageToVideo,
        createdBy: userId
        // imageName: uploadObj.imageName,
        // contentType: uploadObj.contentType,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.uploadIPVMerge,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/UploadIPVMerge",
  //     body: uploadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AUploadIpvSafari = (
  callback: CallableFunction,
  uploadObj: any
) => {
  console.log("AUploadIpvSafari called");

  apiService(
    {
      url: "DIYAPI/ImagetoVideoIpv",
      body: {
        ClientPrimaryDetailId: uploadObj.clientprimarydetailid,
        ApplicationId: uploadObj.applicationid,
        LeadId: uploadObj.leadid,
        ContentType: uploadObj.contentType,
        PanNo: uploadObj.panno,
        image64: uploadObj.image64,
        Width: uploadObj.width,
        Height: uploadObj.height,
        IsUpload: 1,
        UtmInfoDetails: "",
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.imagetoVideoIpv,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/ImagetoVideoIpv",
  //     body: uploadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const ASendSms = (callback: CallableFunction, uploadObj: any) => {
  apiService(
    {
      url: "DIYAPI/SelfieLink",
      body: {
        MobNo: uploadObj.mobNo,
        SelfieLink: uploadObj.selfieLinkText,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.selfieLink,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/selfielink",
  //     body: uploadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const ASendSmsV2 = (callback: CallableFunction, uploadObj: any) => {
  apiService(
    {
      url: "Document/SelfieLink",
      body: {
        "applicationId": uploadObj?.applicationId,
        "esigndocumenttype": 0,
        "accountCategory": uploadObj?.accountCategory
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.selfieLink,
    },
    callback
  );
};

export const ASaveIPVerificationDetails = (
  callback: CallableFunction,
  uploadObj: any
) => {
  apiService(
    {
      url: "IPV/Save",
      body: {
        LeadId: uploadObj.leadid,
        ClientPrimaryDetailId: uploadObj.clientprimarydetailid,
        ApplicationId: uploadObj.applicationid,
        PlaceOfDeclaration: uploadObj.placeofDeclaration,
        EmpName: uploadObj.empName,
        Designation: uploadObj.designation,
        Branch: uploadObj.branch,
        EmpCode: uploadObj.empCode,
        Organization: uploadObj.organization,
        OrganizationCode: uploadObj.organizationCode,
        GeoLocation: uploadObj.geo_location,
        IpAddress: uploadObj.ipaddress,
        Is_AllDocUploaded: true,
        IpvLink: uploadObj.ipvlink ? uploadObj.ipvlink : "",
        latitude: uploadObj.latitude,
        longitude: uploadObj.longitude,
        source: uploadObj.source,
        createdBy:uploadObj?.createdBy,
        geoLocationCity: uploadObj?.geoLocationCity || "",
        geoLocationCountry: uploadObj?.geoLocationCountry || ""
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.saveIpverificationDetails,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/save-ipverification-details",
  //     body: uploadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
